import React from "react";
// import "../Styles/SectionHeader";
import "../Styles/SectionHeader.css";

const SectionHeader = ({ title, subtitle }) => {
  return (
    <div className="section-header">
      <h2 className="title">{title}</h2>
      <p className="subtitle">{subtitle}</p>
    </div>
  );
};

export default SectionHeader;
